import { SxProps, Theme } from "@mui/material";

interface IconWrapperProps {
  IconComponent: React.ElementType;
  sx?: SxProps<Theme>;
  fontSize?: "small" | "medium" | "large" | "inherit";
}

export const AudioIconWrapper: React.FC<IconWrapperProps> = ({ IconComponent, sx, fontSize = "medium" }) => {
  return <IconComponent sx={{ width: "30px", height: "30px", color: "white", ...sx }} fontSize={fontSize} />;
};
